import classNames from 'classnames';
import React from 'react';
import './index.scss';
import { Collapse } from 'antd-v5';

export interface EfFaqItemProps {
    /**
     * 标题
     */
    title: string;
    /**
     * 描述
     */
    desc: string;
}
export interface EfFaqProps {
    /**
     * 样式名
     */
    className?: string;

    /**
     * 列表
     */
    items: EfFaqItemProps[];
}
/**
 * 维护: 谢保林
 */
const EfFaq: React.FC<EfFaqProps> = ({ items = [], className }) => {
    const prefixCls = `ef-faq`;
    const classes = classNames(prefixCls, 'ef-container', className);

    return (
        <Collapse ghost={true} className={classes} defaultActiveKey={0} expandIconPosition="right">
            {items?.map((item, k: number) => (
                <Collapse.Panel className={`${prefixCls}-item`} key={k} header={item.title}>
                    <div className={`${prefixCls}-desc`} dangerouslySetInnerHTML={{ __html: item.desc }} />
                </Collapse.Panel>
            ))}
        </Collapse>
    );
};

export default EfFaq;
